<template>
  <div class="music-form" :class="{'loading': isLoading }">
      <h3>{{ title }}</h3>
      <hr>
      <AppTextField
            v-model="form.name"
            :error="errors.name"
            :disabled="isLoading"
      >
          Name / Title
      </AppTextField>

        <div class="input-wrapper--inverse">
            <div class="input-wrapper">
                <AppTextField
                    v-model="form.price"
                    :error="errors.price"
                    placeholder="$"
                    :disabled="isLoading"
                >
                    Price
                </AppTextField>
                <AppDropdown
                    v-model="form.billing_cycle"
                    :options="billingItems"
                    :error="errors.billing_cycle"
                    placeholder="Select Duration"
                    :disabled="isLoading"
                >
                    Billing Cycle
                </AppDropdown>
                <AppTextField
                    v-if="parseInt(form.is_discounted) === 1"
                    v-model="form.duration"
                    :error="errors.duration"
                    placeholder="Enter Days"
                    :disabled="isLoading"
                >
                    Days
                </AppTextField>
            </div>
      </div>

        <div class="input-wrapper">
            <div class="input-wrapper--inverse radio-group">
                <label>Discount</label>
                <div class="input-wrapper">
                    <AppRadioButton
                            :value="1"
                            v-model="form.is_discounted"
                            name="radiobutton"
                            :disabled="isLoading"
                        >
                            Yes
                        </AppRadioButton>

                        <AppRadioButton
                            :value="0"
                            v-model="form.is_discounted"
                            name="radiobutton"
                            :disabled="isLoading"
                        >
                            No
                        </AppRadioButton>
                </div>
            </div>

            <div class="price-discount">
                <AppTextField
                    v-if="!!parseInt(form.is_discounted)"
                    v-model="form.discount"
                    placeholder="$"
                    :disabled="isLoading"
                >
                    Price Discount
                </AppTextField>
            </div>
        </div>

        <div class="input-wrapper--inverse date-fields" v-if="!!parseInt(form.is_discounted)">
            <span>Discount Duration</span>
            <div class="input-wrapper">
                <AppDatePicker
					v-model="form.discount_duration_from"
                    :min="new Date()"
                    :disabled="isLoading"
				>
					From
				</AppDatePicker>
                <AppDatePicker
					v-model="form.discount_duration_to"
                    :min="form.discount_duration_from || new Date()"
                    :disabled="isLoading"
				>
					To
				</AppDatePicker>
            </div>
      </div>

      <div class="actions">
          <AppButton modifier="small-danger" @click="$emit('cancel')" :disabled="isLoading">
                Cancel
            </AppButton>
            <AppButton modifier="small-primary" @click="handleSubmit" :disabled="isLoading">
                {{ submitText }}
            </AppButton>
      </div>
  </div>
</template>

<script>
import AppDropdown from '@/components/AppDropdown'
import AppButton from '@/components/AppButton'
import AppTextField from '@/components/AppTextField'
import AppDatePicker from '@/components/AppDatePicker'
import AppRadioButton from '@/components/AppRadioButton'
import subscriberPlan from '@/store/subscriber-plan/app.js'
import { errorMessage } from '@/utils/helpers'
import { rawSubscriptionPlanError } from '@/utils/meta'
import { mapFields } from 'vuex-map-fields'
const messageDict = {
	billing_cycle: 'billing cycle',
	discount_duration_to: 'discount duration to',
	discount_duration_from: 'discount duration from'
}

export default {
	props: {
		title: {
			type: String,
			default: 'Upload New Music'
		}
	},
	methods: {
		handleSubmit () {
			const form = { ...this.form }
			if (!this.form.is_discounted) {
				delete form.discount
				delete form.duration
				delete form.discount_duration_to
				delete form.discount_duration_from
			}
			this.errors = { ...rawSubscriptionPlanError }
			for (const key in form) {
				const value = this.form[key]
				if (value === null || (typeof value === 'string' && !value.trim().length)) {
					const field = [
						'billing_cycle',
						'discount_duration_to',
						'discount_duration_from'
					].includes(key) ? messageDict[key] : key
					this.errors[key] = errorMessage.required(field)
				}
				if (key === 'name' && value.trim().length > 30) {
					this.errors[key] = 'Name/Title must be 30 characters or below.'
				}
			}
			Object.keys(this.errors).every(key => !this.errors[key]) && this.$emit('submit')
		}
	},
	created () {
		this.errors = { ...rawSubscriptionPlanError }
	},
	computed: {
		...mapFields('subscriberPlan', ['form', 'errors', 'isLoading']),
		billingItems () {
			return [
				'Monthly',
				'Annual'
			]
		},
		submitText () {
			return this.$route.name === 'SubscriberPlansCreate' ? 'Add' : 'Update'
		}
	},
	beforeCreate () {
		if (!this.$store.hasModule('subscriberPlan')) {
			this.$store.registerModule('subscriberPlan', subscriberPlan)
		}
	},
	components: {
		AppDropdown,
		AppButton,
		AppRadioButton,
		AppTextField,
		AppDatePicker
	}
}
</script>

<style lang="scss" scoped>
.music-form {
    display: flex;
    flex-direction: column;
}

/deep/ .app-text-field {
    margin-bottom: 22px;
    // color: darken($danger, 30%);

    &:first-of-type {
        margin-top: 22px;
    }
}

.date-fields {
    margin-top: 16px;
}
.radio-group {
    margin-top: 24px;
    flex-basis: 29%;
    label {
        margin-bottom: 12px;
    }
}

.price-discount {
    flex-basis: 29%;
    margin-top: 24px;
    margin-left: 24px;
}
.input-wrapper {
    display: flex;
    .app-dropdown {
        margin: 0 12px;
        &:last-of-type {
            margin-right: 0;
        }
        width: 100%;
    }

    .app-text-field {
        width: 100%;
        margin: 0;
    }

    &--inverse {
        display: flex;
        flex-direction: column;

        span {
            margin-bottom: 6px;
        }
    }
}

.app-date-picker:first-of-type {
    margin-right: 12px;
}

.music-player {
    margin: 22px 0 100px 0;
}

.actions {
    display: flex;
    justify-content: space-between;
    margin: 48px 0;
    .app-button {
        width: 80px;
        padding: 8px 0;
    }
}

.app-radio-button {
    &:first-child {
        margin-right: 16px;
    }
   ::v-deep &__mark {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #2F2E50;
		background-color: #fff;
		height: 1em;
		width: 1em;
		border-radius: 50%;
		margin-right: 5px;

	}
    ::v-deep &:hover ~ &__ {
        border-color: #2F2E50;
    }

	::v-deep &__input:checked ~ &__mark {
		background-color: #2F2E50;
		border-color: #2F2E50;
	}
}

</style>
